import { useId } from "react";
import classNames from "classnames";

function HintArrow({ className }) {
  const id = useId();

  return (
    <div className={classNames("flex flex-row w-max", className)}>
      <div
        className={classNames(
          "w-max h-max pxs-hint-arrow pxs-hint-arrow-animation"
        )}
        style={{ clipPath: `url(#${id})` }}
      >
        <svg width="68" height="8" xmlns="http://www.w3.org/2000/svg">
          <clipPath id={id}>
            <path d="M0.646309 3.64645C0.45105 3.84171 0.45105 4.15829 0.646309 4.35355L3.82829 7.53553C4.02355 7.7308 4.34013 7.7308 4.5354 7.53553C4.73066 7.34027 4.73066 7.02369 4.5354 6.82843L1.70697 4L4.5354 1.17157C4.73066 0.976311 4.73066 0.659728 4.5354 0.464466C4.34013 0.269204 4.02355 0.269204 3.82829 0.464466L0.646309 3.64645ZM68.0073 3.5L0.999863 3.5V4.5L68.0073 4.5V3.5Z" />
          </clipPath>
        </svg>
      </div>
    </div>
  );
}

export default HintArrow;
